import React from 'react';
import {
    Container,
    Typography,
    Paper,
    Divider,
} from '@mui/material';
import LegendSection from '../RailLegendSection';
import imagePlaceholder from '../../assets/integrated_map.jpeg'; // Adjust the path as needed
import { railLegend, stations } from '../../enum/railLegend';
import StationLegendSection from '../StationLegendSection';


function MapPage() {
    return (
        <Container maxWidth="xl" sx={{ py: 5 }}>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
                Integrated Transit Map
            </Typography>
            <Divider sx={{ mb: 3 }} />

            {/* Map Image Placeholder */}
            <Paper
                elevation={4}
                sx={{
                    width: '100%',
                    maxWidth: { lg: 600 },
                    minHeight: 400,
                    p: 3,
                    borderRadius: 3,
                    bgcolor: '#fafafa',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '1px solid #e0e0e0',
                    mb: 4,
                    mx: 'auto',
                    overflow: 'hidden',  // Important to clip the zoomed image
                }}
            >
                <img
                    src={imagePlaceholder}
                    alt="Integrated Transit Map"
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                        borderRadius: 12,
                        boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
                        transition: 'transform 0.3s ease',
                        cursor: 'zoom-in',
                    }}
                    onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.2)'}
                    onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                />
            </Paper>

            {/* Legend Sections */}
            <LegendSection title="Rail Lines" items={railLegend} />
            <StationLegendSection title="Key Stations" items={stations} />
        </Container>
    );
}

export default MapPage;
